module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-up-9dc3055fdd24bf7aab89797f806c5cad.svg";